<script lang="ts" setup>
import type { StockLog } from '@gmao/types';
import { AmosCode, EmplacementName, StoreName } from '@gmao/shared';

defineProps<{
  stocksLogs: StockLog[];
}>();
</script>

<template>
  <n-collapse
    v-if="stocksLogs.length"
    mt-2
  >
    <n-collapse-item
      title="Stocks logs"
      name="1"
    >
      <n-table
        :bordered="false"
        :single-line="false"
        size="small"
      >
        <thead>
          <tr>
            <th>AMOS Code</th>
            <th>Emplacement</th>
            <th text-center>
              Qty used
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="stockLog in stocksLogs"
            :key="stockLog.id"
          >
            <td><AmosCode :amos-code="stockLog.amosCode" /></td>
            <td
              flex
              items-center
              gap-1
            >
              <StoreName :name="stockLog.storeName" />
              <EmplacementName :name="stockLog.emplacementName" />
            </td>
            <td text-center>
              {{ stockLog.quantity }}
            </td>
          </tr>
        </tbody>
      </n-table>
    </n-collapse-item>
  </n-collapse>
</template>
